
import {
  GET_SEARCH_RA_REQUEST,
  GET_SEARCH_RA_SUCCESS,
  GET_SEARCH_RA_ERROR
} from "../actions/types";

export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_SEARCH_RA_REQUEST:
      return {
        loading: true,
      };
    case GET_SEARCH_RA_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_SEARCH_RA_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};